import React from 'react';
import PropTypes from 'prop-types';
import {Control} from 'react-redux-form';

class SelectContacts extends React.Component {

  static propTypes = {
    model: PropTypes.string.isRequired,
    selectableContactTypes: PropTypes.arrayOf(PropTypes.string),

    // Override label descriptions: (value, label) => new label
    mapLabels: PropTypes.func
  };

  render() {
    let contactTypes = {
      selected: 'Contact',
      parents_all: 'All parents',
      parents_primary: 'Primary parents',
      parents_financial: 'Financially responsible parents',
      parents_in_primary_household: 'All parents in the primary households',
      parents_female: 'Mothers',
      parents_male: 'Fathers',
      consultants: 'Consultants',
    };

    const { model, mapLabels = (value, label) => label, required = true, customer, selectableContactTypes } = this.props;
    if (customer && customer.modules.includes('billing')){
      contactTypes['payers'] = 'Responsible payers'
    }

    const requiredValidator = required ? { required: (val) => val && val.length } : {};
    const localSelectableContactTypes = selectableContactTypes || Object.keys(contactTypes)

    return <div className="select-contacts">
      {localSelectableContactTypes.map(type => (
        <label key={type} className="checkbox">
          <Control.checkbox
            model={model}
            value={type}
            validators={requiredValidator}
            defaultChecked={localSelectableContactTypes.length <= 1 ? type : undefined}
            className='form-check-inline'
          />
          {mapLabels(type, contactTypes[type])}
        </label>
      ))}
    </div>;
  }
}

export default SelectContacts;
